import { type ReactNode } from 'react'
import { cn } from '@utils/helpers'

interface AppTemplateProps {
  header?: ReactNode
  children: ReactNode
  className?: string
}

export function AppTemplate({ header, children, className }: AppTemplateProps) {
  return (
    <div className={cn('flex flex-col w-full min-w-0 h-full min-h-screen bg-background overflow-x-hidden', className)}>
      {header}
      <div className="flex flex-col flex-1 justify-start lg:justify-center items-center sm:px-6 md:px-8 md:py-6 lg:px-12 lg:py-8 xl:px-16">
        <div className="flex w-full flex-col items-center gap-4 sm:gap-6 md:flex-row md:items-center md:justify-center md:gap-8 lg:gap-12 xl:gap-16">
          {children}
        </div>
      </div>
    </div>
  )
}
